export const actorType = {
  OBJECT: 'OBJECT',
};
